import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import CookbookModel from '../../models/cookbook';

interface CookbookState {
  recipe: CookbookModel | null;
}

const initialState: CookbookState = {
  recipe: null,
};

const cookbookSlice = createSlice({
  name: 'cookbook',
  initialState,
  reducers: {
    setRecipe(state, action: PayloadAction<CookbookModel>) {
      state.recipe = action.payload;
    },
    updateRecipeCookbook(state, action: PayloadAction<CookbookModel>) {
      state.recipe = { ...action.payload };
    },
    clearRecipe(state) {
      state.recipe = null;
    }
  }
});

export const { setRecipe, updateRecipeCookbook, clearRecipe } = cookbookSlice.actions;

export default cookbookSlice.reducer;
